import { isDdirOrigin, isLocalPreviewOrigin } from './ddirOrigins.js';

const THEMES = new Set(['dark', 'light', 'high-contrast']);

export function acceptsParentTheme(event, parent, ownOrigin, dev = false) {
  return event.source === parent && (isDdirOrigin(event.origin) || isLocalPreviewOrigin(event.origin, ownOrigin, dev))
    && event.data?.type === 'ddir-theme' && THEMES.has(event.data.theme);
}

export function readParentTheme(cookie) {
  const value = /(?:^|;\s*)ddir-theme=([^;]*)/.exec(cookie || '')?.[1];
  return THEMES.has(value) ? value : null;
}

export function applyTheme(theme, root) {
  if (!THEMES.has(theme)) return;
  root.classList.toggle('dark', theme !== 'light');
  root.classList.toggle('light', theme === 'light');
  root.classList.toggle('high-contrast', theme === 'high-contrast');
}
